// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const CategoryIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="CategoryIcon" ref={forwardedRef} {...props}>
      <path d="m10 1 4.33 7.5H5.67zM8.268 7h3.464L10 4z" />
      <path d="M14.375 17.625a3.875 3.875 0 1 0 0-7.75 3.875 3.875 0 0 0 0 7.75m0-1.5a2.375 2.375 0 1 1 0-4.75 2.375 2.375 0 0 1 0 4.75" />
      <path d="M2 10.25v7h7v-7zm5.5 1.5v4h-4v-4z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const CategoryIcon = /* @__PURE__ */ Object.assign(
  CategoryIconComponent,
  { displayName: 'CategoryIcon' },
);
